/** Kamus en/id dan penerjemah murni (tanpa DOM/React), dipakai web dan worker. */
import en from "./en.json";
import id from "./id.json";

export type Lang = "en" | "id";
export type Vars = Record<string, string | number>;

type Leaves<T, P extends string = ""> = {
  [K in keyof T & string]: T[K] extends string ? `${P}${K}` : Leaves<T[K], `${P}${K}.`>;
}[keyof T & string];
type Base<S> = S extends `${infer B}_one` ? B : S extends `${infer B}_other` ? B : S;
/** Semua key di en.json; `x_one`/`x_other` dipanggil sebagai `x` dengan vars.count. */
export type Key = Base<Leaves<typeof en>>;

const DICT: Record<Lang, unknown> = { en, id };

function lookup(lang: Lang, path: string): string | undefined {
  let v: unknown = DICT[lang];
  for (const p of path.split(".")) v = typeof v === "object" && v !== null ? (v as Record<string, unknown>)[p] : undefined;
  return typeof v === "string" ? v : undefined;
}

/** Terjemahkan key; `count` memilih `_one`/`_other`. Fallback: bahasa → en → key itu sendiri. */
export function translate(lang: Lang, key: Key, vars?: Vars): string {
  const keys =
    typeof vars?.count === "number"
      ? [`${key}_${new Intl.PluralRules(lang).select(vars.count) === "one" ? "one" : "other"}`, key]
      : [key, `${key}_other`];
  let s: string | undefined;
  for (const l of [lang, "en"] as const) for (const k of keys) s ??= lookup(l, k);
  return (s ?? key).replace(/\{(\w+)\}/g, (m, n: string) => (vars && n in vars ? String(vars[n]) : m));
}

/** Tag bahasa (navigator.language / Accept-Language) → Lang: berawalan `id`/`in` (legacy) → id, selain itu en. */
export const langFrom = (tag: string | null | undefined): Lang =>
  tag && /^(id|in)\b/.test(tag.trim().toLowerCase()) ? "id" : "en";
